// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen` from
// x-flags.doRenderReactQueryQueryHook on POST /team/profile-get.

import { useQuery, type UseQueryOptions } from "@tanstack/react-query";
import type {
  typeTeamProfileGetBody,
  typeTeamProfileGetOutput200,
} from "../../sdk/team/postTeamProfileGet";
import useCallSdk from "../../sdk-helpers/useCallSdk";

export function buildTeamProfileGetQueryKey(
  payload: typeTeamProfileGetBody,
): string[] {
  const queryKeySegments: string[] = [];
  queryKeySegments.push(`teamId:${JSON.stringify(payload.teamId)}`);
  return ["post:team:teamProfileGet", "svc:sports-api", ...queryKeySegments];
}

type QueryOptions = Partial<
  UseQueryOptions<
    typeTeamProfileGetOutput200,
    unknown,
    typeTeamProfileGetOutput200,
    string[]
  >
> & {
  // Isolates two callers that query the same data for independent UI state
  // (e.g. a dropdown search vs a table both listing the same resource).
  queryKeyIdentifier?: string;
};

export default function useTeamProfileGet(
  payload: typeTeamProfileGetBody,
  options?: QueryOptions,
) {
  // No staleTime default here on purpose. Freshness is the consuming app's
  // decision and belongs in its QueryClient, in one place: a default set on the
  // hook would silently beat it for every screen. Pass one per call to override.
  const resolvedOptions = options ?? {};

  let queryKey = buildTeamProfileGetQueryKey(payload);
  if (resolvedOptions.queryKeyIdentifier) {
    queryKey = [...queryKey, resolvedOptions.queryKeyIdentifier];
  }

  const { callSdk } = useCallSdk();
  return useQuery({
    queryKey,
    queryFn: () => callSdk().postTeamProfileGet(payload),
    ...resolvedOptions,
  });
}
